import { render, staticRenderFns } from "./InvoiceDisputesDialog.vue?vue&type=template&id=316d4d1e&scoped=true&"
import script from "./InvoiceDisputesDialog.vue?vue&type=script&lang=ts&"
export * from "./InvoiceDisputesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316d4d1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('316d4d1e')) {
      api.createRecord('316d4d1e', component.options)
    } else {
      api.reload('316d4d1e', component.options)
    }
    module.hot.accept("./InvoiceDisputesDialog.vue?vue&type=template&id=316d4d1e&scoped=true&", function () {
      api.rerender('316d4d1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_dialogs/InvoiceDisputesDialog.vue"
export default component.exports